import { useContext, useMemo } from 'react';

import dayjs from 'dayjs';
import { Column } from 'react-table';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { ECondition, EReward, TAchievement } from './interfaces';
import { getAchievementConditionText, getAchievementRewardText } from './utils';

export const UseGetColumns = (): Column<TAchievement>[] => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);
  return useMemo(
    () => [
      {
        Header: t('title'),
        accessor: 'name',
        width: 170,
      },
      {
        Header: t('createdAt'),
        accessor: 'created_at',
        Cell: ({ row }) => {
          return (
            <div>{dayjs(row?.original?.created_at).format('DD.MM.YYYY')}</div>
          );
        },
        width: 170,
      },
      {
        Header: t('attained'),
        accessor: 'assigned_count',
        Cell: ({ row }) => {
          return (
            <div>
              {row?.original?.assigned_count} {t('times')}
            </div>
          );
        },
        width: 130,
      },
      {
        Header: t('achievements.condition'),
        accessor: 'conditions',
        Cell: ({ value }: { value: { name: ECondition; value: number }[] }) => (
          <span>{getAchievementConditionText(value, currency.sign, t)}</span>
        ),
        width: 300,
      },

      {
        Header: t('achievements.reward'),
        accessor: 'rewards',
        Cell: ({
          value,
        }: {
          value: Array<{ name: EReward; value: number }>;
        }) => (
          <span>
            {value.length > 0
              ? getAchievementRewardText(value[0], currency.sign, t)
              : t('achievements.reward.none')}
          </span>
        ),
        width: 300,
      },
    ],
    [t]
  );
};
